var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-actions"},[_c('a',{staticClass:"btn btn-sm",attrs:{"href":'/' + _vm.modeltype + '/profile/' + _vm.rowData.id}},[_c('i',{staticClass:"fa fa-search-plus"})])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07fc7433","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Players/CustomActions.vue
// module id = MfQz
// module chunks = 0